import { Controller } from '@hotwired/stimulus';
/*
 * Description
 * -------
 *
 * Shows WLA messages icon and sets its style based on wlaChromecastStatus event.
 *
 * Can be used on any element.
 * Can be used multiple times in the document.
 *
 * Usage
 * -------
 *
 * <button
 *   data-controller="wla-messages-icon"
 *   data-action="wlaChromecastStatus@document->wla-messages-icon#handleEvent"
 * >
 *  Messages
 * </button>
 */
export class WlaMessagesIcon extends Controller {
    handleEvent(e) {
        this.element.classList.remove('hidden');
        if (e.detail.visible) {
            this.element.style.marginRight = '48px';
        }
        else {
            this.element.style.marginRight = '0px';
        }
    }
}
